<dff-side [observable]="initObservable">
    @if (!vm) {
        <mat-spinner class="mat-spinner"></mat-spinner>
    }
    @if (vm) {
        <dff-side-titel class="sr-only">{{ vm.sideTitel }} </dff-side-titel>

        <!-- Tiles -->
        @if (vm.umbracoMitForbrug.tiles.length) {
            <mit-forbrug-carousel>
                @for (tile of vm.umbracoMitForbrug.tiles; track tile; let index = $index) {
                    <e-forsyning-features-mit-forbrug-tile
                        appCarouselCard
                        [attr.id]="'mit-forbrug-tile-' + index"
                        [tile]="tile"
                        (click)="onTileClick(tile)"
                        (keydown.enter)="onTileClick(tile)"
                        (keydown.space)="onTileClick(tile)"
                        [attr.role]="tile.type === 'Vejret' ? 'button' : 'link'"
                        [attr.aria-label]="getTileLabel(tile.type)"
                        tabindex="0"
                    ></e-forsyning-features-mit-forbrug-tile>
                }
            </mit-forbrug-carousel>
        }

        <!-- Infobox -->
        @if (vm.umbracoMitForbrug.infoBoks && vm.umbracoMitForbrug.infoBoks.infoboksOverskrift) {
            <mit-forbrug-info-box [infoBox]="vm.umbracoMitForbrug.infoBoks"></mit-forbrug-info-box>
        }

        <!-- Chart: Forbrug -->

        <panel titel="Forbrug" id="forbrug-chart-panel">
            @if (vm.forbrugPanelOpenState) {
                <div @myInsertRemoveTrigger>
                    <div class="panel-title-content">
                        <button mat-icon-button title="Hent aflæsninger til regneark" aria-label="Hent aflæsninger til regneark" (click)="downloadAflaesFile()">
                            <mat-icon svgIcon="mit-forbrug-download"></mat-icon>
                        </button>
                    </div>
                    <mat-button-toggle-group
                        color="primary"
                        class="grid grid-columns-3"
                        [value]="vm.selectedInterval"
                        (change)="onForbrugSelectedIntervalChange($event)"
                        role="tablist"
                        aria-label="Vælg interval for forbrug"
                        tabindex="0"
                    >
                        @if (vm.umbracoMitForbrug.forbrugsgraf.faner.aar) {
                            <mat-button-toggle
                                id="forbrugs-button-3"
                                [value]="3"
                                [attr.aria-controls]="'forbrug-chart-3'"
                                [attr.aria-selected]="vm.selectedInterval === 3"
                                role="tab"
                                >År</mat-button-toggle
                            >
                        }
                        @if (vm.umbracoMitForbrug.forbrugsgraf.faner.maaned) {
                            <mat-button-toggle
                                id="forbrugs-button-1"
                                [value]="1"
                                [attr.aria-controls]="'forbrug-chart-1'"
                                [attr.aria-selected]="vm.selectedInterval === 1"
                                role="tab"
                                >Måned</mat-button-toggle
                            >
                        }
                        @if (vm.umbracoMitForbrug.forbrugsgraf.faner.dag) {
                            <mat-button-toggle
                                id="forbrugs-button-0"
                                [attr.testId]="'qa-forbrug-dag-toggle'"
                                [value]="0"
                                [attr.aria-controls]="'forbrug-chart-0'"
                                [attr.aria-selected]="vm.selectedInterval === 0"
                                role="tab"
                                >Dag</mat-button-toggle
                            >
                        }
                    </mat-button-toggle-group>
                </div>
            }
            <div
                class="chart-container"
                [attr.id]="'forbrug-chart-' + vm.selectedInterval"
                [attr.aria-labelledby]="'forbrugs-button-' + vm.selectedInterval + '-button'"
                aria-hidden="false"
            >
                <div id="forbrug-chart"></div>
                @if (vm.forbrugsgrafLoading$ | async) {
                    <mat-spinner class="mat-spinner"></mat-spinner>
                }
            </div>
            @if (vm.forbrugPanelOpenState) {
                <div @myInsertRemoveTrigger>
                    <button
                        class="chart-navigation-button"
                        (click)="prevButtonForbrug()"
                        [attr.aria-controls]="'forbrug-chart-' + vm.selectedInterval"
                        role="button"
                        type="button"
                    >
                        Gå tilbage på forbrugs graf
                    </button>
                    <button
                        class="chart-navigation-button"
                        (click)="nextButtonForbrug()"
                        [attr.aria-controls]="'forbrug-chart-' + vm.selectedInterval"
                        role="button"
                        type="button"
                    >
                        Gå frem på forbrugs graf
                    </button>
                    <div class="forbrug-chart-extras">
                        <mat-slide-toggle
                            [class]="
                                vm.selectedInterval !== 1 || !vm.umbracoMitForbrug.forbrugsgraf.faner.maanedSammenlign ? 'sammenlign sammenlign-hidden' : 'sammenlign'
                            "
                            color="primary"
                            [checked]="vm.sammenlign !== 0"
                            [disabled]="vm.selectedInterval !== 1 || !vm.umbracoMitForbrug.forbrugsgraf.faner.maanedSammenlign"
                            [attr.aria-hidden]="vm.selectedInterval !== 1 || !vm.umbracoMitForbrug.forbrugsgraf.faner.maanedSammenlign"
                            (toggleChange)="sammenlignFunk()"
                        >
                            Vis forbrug for tidligere år
                        </mat-slide-toggle>
                        @if (!vm.umbracoMitForbrug.forbrugsgraf.skjulForkerteDataFormular) {
                            <button mat-stroked-button (click)="sendFejlData()" type="button" role="button" aria-label="Åben Oplever du forkerte data dialog">
                                Oplever du forkerte data?
                            </button>
                        }
                    </div>
                    @if (!vm.umbracoMitForbrug.forbrugsgraf.visKunEnergi) {
                        <mat-button-toggle-group
                            color="primary"
                            class="grid grid-columns-3"
                            [value]="vm.optionSelected"
                            (change)="onForbrugTaellevaerkChange($event)"
                            role="tablist"
                            aria-label="Vælg interval for forbrug"
                            tabindex="0"
                        >
                            @if (vm.eng1Visibility) {
                                <mat-button-toggle
                                    id="form-field-forbrug-chart-unit-eng1"
                                    [attr.testId]="'qa-forbrug-taellevaerk1-toggle'"
                                    [value]="'ENG1'"
                                    [attr.aria-controls]="'forbrug-chart-1'"
                                    role="tab"
                                    [attr.aria-selected]="vm.selectedInterval === 1"
                                    >{{ vm.eng1Caption }}
                                </mat-button-toggle>
                            }
                            @if (vm.m3Visibility) {
                                <mat-button-toggle
                                    id="form-field-forbrug-chart-unit-m3"
                                    [attr.testId]="'qa-forbrug-taellevaerk2-toggle'"
                                    [value]="'M3'"
                                    [attr.aria-controls]="'forbrug-chart-0'"
                                    role="tab"
                                    [attr.aria-selected]="vm.selectedInterval === 0"
                                    >{{ vm.m3Caption }}
                                </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    }
                </div>
            }
            <button
                class="show-more-button"
                role="button"
                type="button"
                (keydown.enter)="toggleForbrugPanel()"
                (keydown.space)="toggleForbrugPanel()"
                mat-raised-button
                (click)="toggleForbrugPanel()"
            >
                {{ vm.forbrugPanelButtonText }}
                <mat-icon svgIcon="{{ vm.panemToggleIcon }}"></mat-icon>
            </button>
        </panel>

        <!-- Chart: Temperatur -->
        @if (vm.umbracoMitForbrug.temperaturgraf.synlig) {
            <panel titel="Temperatur" id="temperatur-chart-panel">
                @if (vm.temperaturPanelOpenState) {
                    <mat-button-toggle-group
                        color="primary"
                        class="grid grid-columns-3"
                        [value]="vm.tempSelectedInterval"
                        (change)="onTemperaturSelectedIntervalChange($event)"
                        role="tablist"
                        aria-label="Vælg interval for temperatur"
                        tabindex="0"
                    >
                        @if (vm.umbracoMitForbrug.temperaturgraf.faner.aar) {
                            <mat-button-toggle [value]="3" [attr.aria-controls]="'temperatur-chart-3'" [attr.aria-selected]="vm.selectedInterval === 3" role="tab"
                                >År</mat-button-toggle
                            >
                        }
                        @if (vm.umbracoMitForbrug.temperaturgraf.faner.maaned) {
                            <mat-button-toggle [value]="1" [attr.aria-controls]="'temperatur-chart-1'" [attr.aria-selected]="vm.selectedInterval === 1" role="tab"
                                >Måned</mat-button-toggle
                            >
                        }
                        @if (vm.umbracoMitForbrug.temperaturgraf.faner.dag) {
                            <mat-button-toggle [value]="0" [attr.aria-controls]="'temperatur-chart-0'" [attr.aria-selected]="vm.selectedInterval === 0" role="tab"
                                >Dag</mat-button-toggle
                            >
                        }
                    </mat-button-toggle-group>
                }

                <div
                    class="chart-container"
                    [attr.id]="'temperatur-chart-' + vm.selectedInterval"
                    [attr.aria-labelledby]="'temperatur-button-' + vm.selectedInterval + '-button'"
                    aria-hidden="false"
                >
                    <div id="temperatur-chart"></div>
                    @if (vm.temperaturgrafLoading$ | async) {
                        <mat-spinner class="mat-spinner"></mat-spinner>
                    }
                </div>
                <button
                    class="chart-navigation-button"
                    (click)="prevButtonTemperatur()"
                    [attr.aria-controls]="'temperatur-chart-' + vm.selectedInterval"
                    role="button"
                    type="button"
                >
                    Gå tilbage på temperatur graf
                </button>
                <button
                    class="chart-navigation-button"
                    (click)="nextButtonTemperatur()"
                    [attr.aria-controls]="'temperatur-chart-' + vm.selectedInterval"
                    role="button"
                    type="button"
                >
                    Gå frem på temperatur graf
                </button>
                @if (vm.temperaturPanelOpenState) {
                    @if (vm.beskrivOverskrift || vm.tempGrafBeskriv) {
                        <dff-side-tekst [titel]="vm.beskrivOverskrift" [tekst]="vm.tempGrafBeskriv"></dff-side-tekst>
                    }
                }
                <button
                    class="show-more-button"
                    mat-raised-button
                    role="button"
                    type="button"
                    (keydown.enter)="toggleTemperaturPanel()"
                    (keydown.space)="toggleTemperaturPanel()"
                    (click)="toggleTemperaturPanel()"
                >
                    {{ vm.temperaturPanelButtonText }}
                    <mat-icon svgIcon="se-mere-mitforbrug"></mat-icon>
                </button>
            </panel>
        }
    }
</dff-side>
